<template>
    <div>
        <card-header title="Mass E-Mail" icon="fa-envelope"/>

        <card-body>
            <card-list>
                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Subject" label-position="inside">
                                <b-input v-model="email.subject"></b-input>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Addresses" label-position="inside">
                                <b-input type="textarea" v-model="email.addresses"></b-input>
                            </b-field>
                            <div class="help">Separate multiple addresses by a comma (,)</div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-field>
                                <quill-editor v-model="email.body" ref="descriptionEditor" :options="editorOptions" class="has-background-white content"/>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">

                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="processing || !email.subject || !email.addresses || !email.body"
                    ><i class="fas fa-check mr-2"></i>Send E-Mail
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardList from "../../components/common/CardList";
    import SubheaderListItem from "../../components/common/SubheaderListItem";
    import MenuListItem from "../../components/MenuListItem";
    import NavigationListItem from "../../TIER/components/NavigationListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import CardFooter from "../../TIER/components/CardFooter";

    import {client as http} from "@/http_client";

    export default {
        components: {
            CardFooter,
            ContainerListItem,
            NavigationListItem,
            CardHeader,
            CardBody,
            CardList,
            SubheaderListItem,
            MenuListItem
        },

        props: ['card', 'child'],
        data() {
            return {
                email: {
                    subject: '',
                    addresses: '',
                    body: ''
                },
                editorOptions: {},
                processing: false
            };
        },
        methods: {
            submit() {
                if (!this.processing) {
                    this.processing = true;

                    this.$emit('loading', true);

                    http.post('tools/mass-email', this.email, {force: true}).then(response => {
                        this.$closeCard(this.card);
                    }).catch(err => {
                        window.alert('An error occurred while sending.');
                        this.$emit('loading', false);
                        this.processing = false;
                    });
                }
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>
